// https://vuex.vuejs.org/en/actions.html
import contentService from '@/services/contentService'
import store from '@/store'

export default {
  async SetSnackBarMessage (context, message) {
    context.commit('showSnackbar', message)
  },
  async RefreshContentSettings (context) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Loading')
    var apiResult = await contentService.getSettings()
    if (apiResult.success) {
      context.commit('refreshContentSettings', apiResult.value)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
}
